module.exports = __webpack_public_path__ + "media/images/application/icons/icon-user-f0443afccafa0a899ebd00d53d646f03.svg";